import React, { useState, useCallback, useRef, useEffect } from "react";
import { Table } from "antd";
import { Offcanvas } from "react-bootstrap";

import swal from "sweetalert";
import useApiServices from "../../utils/useApiServices";
import {
  DELETE_ALL_RULE,
  GET_WHITELIST_AMOUNT_RULES,
  UPDATE_WHITELIST_RULE,
} from "../../utils/constant";
import DragDropRules from "./DragDropRules";
import { DataGrid } from "@mui/x-data-grid";
import { max } from "lodash";

const ShuffleRulesWhitelist = ({
  showRule,
  setShowRule,
  getAllMerchantsWithTheirRules,
  mid,
  Id,
  viewOnly,
}) => {
  console.log(mid);
  const [data, setData] = useState([]);
  const [editedValues, setEditedValues] = useState(null);
  const [editRowId, setEditRowId] = useState(null);
  const [viewSid, setViewSid] = useState(false);
  const [id, setId] = useState(null);

  const { apiCallFnforGet, apiCallFnforPut } = useApiServices();

  const FetchDataForRules = async () => {
    try {
      const response = await apiCallFnforGet(
        `${GET_WHITELIST_AMOUNT_RULES}/${mid}`
      );
      if (response?.statusCode === 200) {
        setData(response?.data || []);
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
      console.log(error);
    }
  };

  useEffect(() => {
    FetchDataForRules();
  }, [showRule]);

  const handleSidView = async (id) => {
    setViewSid(true);
    setId(id);
  };

  const HandleUpdate = async (row, min, max) => {
    const payload = {
      domain: "",
      id: row?.id,
      isDenied: true,
      mid: row?.mid,
      processor: "",
      prority: 0,
      requestMode: "",
      ruleName: row?.ruleName,
      sid: "",
      sidList: [0],
      txnMaxAmount: max,
      txnMinAmount: min,
    };

    try {
      const response = await apiCallFnforPut(UPDATE_WHITELIST_RULE, payload);
      if (response?.statusCode === 200) {
        swal("Success", "Rules Updated Successfully", "success");
        setShowRule(false);
        setEditRowId(null);
        setEditedValues(null);
        // getAllMerchantsWithTheirRules();
      } else {
        swal("Failed", response?.message, "error");
      }
    } catch (error) {
      swal("Failed", "Somerthing went wrong", "error");
    }
  };

  const HandleDelete = async (id) => {
    try {
      const response = await apiCallFnforPut(`${DELETE_ALL_RULE}/${id}`);
      if (response?.statusCode === 200) {
        swal("Success", "Rules Deleted Successfully", "success");
        setShowRule(false);
        getAllMerchantsWithTheirRules();
      } else {
        swal("Failed", response?.message, "error");
      }
    } catch (error) {
      swal("Failed", "Somerthing went wrong", "error");
    }
  };

  const columns = [
    {
      headerName: "MID",
      field: "mid",
      flex: 1,
    },

    {
      headerName: "Rule Name",
      field: "ruleName",
      flex: 1,
    },
    {
      headerName: "Txn Min Amount",
      field: "txnMinAmount",
      flex: 1,
      renderCell: (params) =>
        editRowId === params.row.ruleId ? (
          <div className="d-flex align-items-cenetr">
            <input
              type="number"
              // className={"align-self-center"}
              value={editedValues.txnMinAmount ?? params.row.txnMinAmount}
              onChange={(e) =>
                setEditedValues((prev) => ({
                  ...prev,
                  txnMinAmount: e.target.value,
                }))
              }
              className="form-control form-control-sm mt-1"
            />
          </div>
        ) : (
          params.row.txnMinAmount
        ),
    },
    {
      headerName: "Txn Max Amount",
      field: "txnMaxAmount",
      flex: 1,
      renderCell: (params) =>
        editRowId === params.row.ruleId ? (
          <div className="d-flex align-items-cenetr">
            <input
              type="number"
              value={editedValues.txnMaxAmount ?? params.row.txnMaxAmount}
              onChange={(e) =>
                setEditedValues((prev) => ({
                  ...prev,
                  txnMaxAmount: e.target.value,
                }))
              }
              className="form-control form-control-sm mt-1"
            />
          </div>
        ) : (
          params.row.txnMaxAmount
        ),
    },

    {
      headerName: "View",
      field: "View",
      flex: 1,
      renderCell: (id) => (
        <button
          className="btn btn-info btn-sm"
          onClick={() => handleSidView(id)}
        >
          View SID's
        </button>
      ),
    },
    {
      headerName: "Action",
      field: "actions",
      flex: 1,
      renderCell: (params) => {
        const isEditing = editRowId === params.row.ruleId;

        return !viewOnly ? (
          <div className="d-flex align-items-center gap-2 justify-content-center mt-1">
            <button
              className="btn btn-danger btn-sm"
              onClick={() => HandleDelete(params.row.ruleId)}
            >
              Delete
            </button>

            {isEditing ? (
              <button
                className="btn btn-primary btn-sm"
                onClick={() => {
                  HandleUpdate(
                    params.row,
                    editedValues.txnMinAmount,
                    editedValues.txnMaxAmount
                  );
                  setEditRowId(params?.row?.ruleId);
                  setEditedValues({});
                }}
              >
                Submit
              </button>
            ) : (
              <button
                className="btn btn-success btn-sm"
                onClick={() => {
                  setEditRowId(params.row.ruleId);
                  setEditedValues({
                    txnMinAmount: params.row.txnMinAmount,
                    txnMaxAmount: params.row.txnMaxAmount,
                  });
                }}
              >
                Update
              </button>
            )}
          </div>
        ) : null;
      },
    },
  ];

  const offcanvasStyle = {
    width: "90vw", // Set width to 70vw
  };

  const [show, setShow] = useState(true);

  const handleClose = () => {
    setShowRule(false);
  };

  return (
    <>
      <Offcanvas
        show={showRule}
        onHide={handleClose}
        placement="end"
        style={offcanvasStyle}
        backdrop="static"
        keyboard={false}
      >
        <div className="d-flex justify-content-start align-items-center">
          <Offcanvas.Header closeButton></Offcanvas.Header>
          <h5
            class="offcanvas-title  fs-2 text-dark fw-bold"
            id="offcanvasLabel"
          >
            Whitelist Routing Rule for {mid}
          </h5>
        </div>
        <Offcanvas.Body>
          <div className="overflow-x-scroll">
            <DataGrid
              rows={data.map((item, index) => ({
                ...item,
                id: item.ruleId || index,
              }))}
              columns={columns}
              pagination={false}
              autoHeight
            />
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      {viewSid && (
        <DragDropRules
          id={id}
          getAllMerchantsWithTheirRules={getAllMerchantsWithTheirRules}
          showRule={viewSid}
          setShowRule={setViewSid}
          viewOnly={viewOnly}
        />
      )}
    </>
  );
};

export default ShuffleRulesWhitelist;
